import React from "react";
import { eventVenueMapUrl } from "../../utils/publicEventsApi";

/** Venue name. A valid http(s) `venueMapUrl` makes that name the map link. */
const EventVenueName = ({ event }) => {
  const name = typeof event?.venue === "string" ? event.venue.trim() : "";
  if (!name) return null;
  const href = eventVenueMapUrl(event);
  if (!href) return name;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="smym-venue-link"
    >
      {name}
    </a>
  );
};

export default EventVenueName;
